import { ConstData } from "./helpers";

export const SCHOOLS: ConstData[] = [
  { title: "Abbotsleigh Senior School", value: "Abbotsleigh Senior School" },
  { title: "Al Amanah College", value: "Al Amanah College" },
  { title: "Al Faisal College", value: "Al Faisal College" },
  { title: "Al Hikma College", value: "Al Hikma College" },
  { title: "Al Noori Muslim School", value: "Al Noori Muslim School" },
  { title: "Al Sadiq College", value: "Al Sadiq College" },
  { title: "Al Zahra College", value: "Al Zahra College" },
  { title: "Alexandria Park Community School", value: "Alexandria Park Community School" },
  { title: "Alexandria Park High School", value: "Alexandria Park High School" },
  { title: "Al-Faisal College", value: "Al-Faisal College" },
  { title: "All Saints Grammar", value: "All Saints Grammar" },
  { title: "Alpha Omega Senior College", value: "Alpha Omega Senior College" },
  { title: "Amity College", value: "Amity College" },
  { title: "Aquinas Catholic College", value: "Aquinas Catholic College" },
  { title: "Arden Anglican School", value: "Arden Anglican School" },
  { title: "Armidale High School", value: "Armidale High School" },
  { title: "Arthur Phillip High School", value: "Arthur Phillip High School" },
  { title: "Ascham School", value: "Ascham School" },
  { title: "Ashfield Boys High School", value: "Ashfield Boys High School" },
  { title: "Asquith Boys High School", value: "Asquith Boys High School" },
  { title: "Asquith Girls High School", value: "Asquith Girls High School" },
  { title: "Auburn Girls High School", value: "Auburn Girls High School" },
  { title: "Australian Christian College", value: "Australian Christian College" },
  { title: "Australian Institute of Music", value: "Australian Institute of Music" },
  { title: "Australian International Academy", value: "Australian International Academy" },
  { title: "Australian Islamic College of Sydney", value: "Australian Islamic College of Sydney" },
  { title: "Australian Performing Arts Grammar School", value: "Australian Performing Arts Grammar School" },
  { title: "Avondale School", value: "Avondale School" },
  { title: "Balgowlah Boys High School", value: "Balgowlah Boys High School" },
  { title: "Bankstown Senior College", value: "Bankstown Senior College" },
  { title: "Barker College", value: "Barker College" },
  { title: "Barker High School", value: "Barker High School" },
  { title: "Bass High School", value: "Bass High School" },
  { title: "Baulkham Hills High School", value: "Baulkham Hills High School" },
  { title: "Bethany College", value: "Bethany College" },
  { title: "Bethlehem College", value: "Bethlehem College" },
  { title: "Beverly Hills Girls High School", value: "Beverly Hills Girls High School" },
  { title: "Birrong Boys High School", value: "Birrong Boys High School" },
  { title: "Birrong Girls High School", value: "Birrong Girls High School" },
  { title: "Bishop Tyrrell Anglican College", value: "Bishop Tyrrell Anglican College" },
  { title: "Blacktown Boys High School", value: "Blacktown Boys High School" },
  { title: "Blacktown Girls High School", value: "Blacktown Girls High School" },
  { title: "Blakehurst High School", value: "Blakehurst High School" },
  { title: "Blue Mountains Grammar School", value: "Blue Mountains Grammar School" },
  { title: "Bonnyrigg High School", value: "Bonnyrigg High School" },
  { title: "Bossley Park High School", value: "Bossley Park High School" },
  { title: "Brigidine College", value: "Brigidine College" },
  { title: "Brigidine College Randwick", value: "Brigidine College Randwick" },
  { title: "Burwood Girls High School", value: "Burwood Girls High School" },
  { title: "Cabramatta High School", value: "Cabramatta High School" },
  { title: "Cambridge Park High School", value: "Cambridge Park High School" },
  { title: "Cammeraygal High School", value: "Cammeraygal High School" },
  { title: "Campsie High School", value: "Campsie High School" },
  { title: "Canbarra Grammar School", value: "Canbarra Grammar School" },
  { title: "Canberra Girls Grammar School", value: "Canberra Girls Grammar School" },
  { title: "Canley Vale High School", value: "Canley Vale High School" },
  { title: "Canterbury Boys High School", value: "Canterbury Boys High School" },
  { title: "Canterbury Girls High School", value: "Canterbury Girls High School" },
  { title: "Caringbah High School", value: "Caringbah High School" },
  { title: "Carlingford High School", value: "Carlingford High School" },
  { title: "Caroline Chisholm College", value: "Caroline Chisholm College" },
  { title: "Caroline Chisholm School", value: "Caroline Chisholm School" },
  { title: "Casimir Catholic College", value: "Casimir Catholic College" },
  { title: "Castle Hill High School", value: "Castle Hill High School" },
  { title: "Casula High School", value: "Casula High School" },
  { title: "Catherine McAuley", value: "Catherine McAuley" },
  { title: "Central Coast Adventist", value: "Central Coast Adventist" },
  { title: "Central Coast Grammar School", value: "Central Coast Grammar School" },
  { title: "Cerdon College", value: "Cerdon College" },
  { title: "Chatswood High School", value: "Chatswood High School" },
  { title: "Cheltenham Girls High School", value: "Cheltenham Girls High School" },
  { title: "Cherrybrook Technology High School", value: "Cherrybrook Technology High School" },
  { title: "Chevalier College", value: "Chevalier College" },
  { title: "Chrestwood High School", value: "Chrestwood High School" },
  { title: "Christ The King School", value: "Christ The King School" },
  { title: "Christian Brothers High School Lewisham", value: "Christian Brothers High School Lewisham" },
  { title: "Concord High School", value: "Concord High School" },
  { title: "Conservatorium High School", value: "Conservatorium High School" },
  { title: "Covenant Christian School", value: "Covenant Christian School" },
  { title: "Cranbrook School", value: "Cranbrook School" },
  { title: "Crestwood High School", value: "Crestwood High School" },
  { title: "Croydon High School", value: "Croydon High School" },
  { title: "Cumberland High School", value: "Cumberland High School" },
  { title: "Danebank Anglican School for Girls", value: "Danebank Anglican School for Girls" },
  { title: "Davidson High School", value: "Davidson High School" },
  { title: "De La Salle Ashfield", value: "De La Salle Ashfield" },
  { title: "De La Salle Revesby", value: "De La Salle Revesby" },
  { title: "Delany College", value: "Delany College" },
  { title: "Denistone East Public School", value: "Denistone East Public School" },
  { title: "Domremy College", value: "Domremy College" },
  { title: "Dulwich Hill High", value: "Dulwich Hill High" },
  { title: "Dural Public School", value: "Dural Public School" },
  { title: "East Hills Boys High School", value: "East Hills Boys High School" },
  { title: "East Hills Girls Technology High School", value: "East Hills Girls Technology High School" },
  { title: "Epping Boys High School", value: "Epping Boys High School" },
  { title: "Erksine Park High School", value: "Erksine Park High School" },
  { title: "Evans High School", value: "Evans High School" },
  { title: "Fairvale High School", value: "Fairvale High School" },
  { title: "Fort Street High School", value: "Fort Street High School" },
  { title: "Freeman Catholic College", value: "Freeman Catholic College" },
  { title: "Frensham School", value: "Frensham School" },
  { title: "Freshwater Senior Campus", value: "Freshwater Senior Campus" },
  { title: "George Hall Public School", value: "George Hall Public School" },
  { title: "Georges River College Hurstville Boys Campus", value: "Georges River College Hurstville Boys Campus" },
  { title: "Georges River College Oatley Senior Campus", value: "Georges River College Oatley Senior Campus" },
  { title: "Georges River Grammar School", value: "Georges River Grammar School" },
  { title: "German International School Sydney", value: "German International School Sydney" },
  { title: "Girraween High School", value: "Girraween High School" },
  { title: "Gleenwood High School", value: "Gleenwood High School" },
  { title: "Glenaeon Rudolf Steiner School", value: "Glenaeon Rudolf Steiner School" },
  { title: "Glenmore Park High", value: "Glenmore Park High" },
  { title: "Glenwood High School", value: "Glenwood High School" },
  { title: "Good Samaritan Catholic College", value: "Good Samaritan Catholic College" },
  { title: "Gosford High School", value: "Gosford High School" },
  { title: "Granville Boys High School", value: "Granville Boys High School" },
  { title: "GRC Penshurst Campus", value: "GRC Penshurst Campus" },
  { title: "Green Point Christian College", value: "Green Point Christian College" },
  { title: "Greenacre Baptist Christian Community School", value: "Greenacre Baptist Christian Community School" },
  { title: "Greenwood School for Girls", value: "Greenwood School for Girls" },
  { title: "Greystanes High School", value: "Greystanes High School" },
  { title: "Gymea Technology High School", value: "Gymea Technology High School" },
  { title: "Hanyong Foreign Language High School", value: "Hanyong Foreign Language High School" },
  { title: "Heathcote High School", value: "Heathcote High School" },
  { title: "Hills Adventist College", value: "Hills Adventist College" },
  { title: "Holroyd High School", value: "Holroyd High School" },
  { title: "Holsworthy High School", value: "Holsworthy High School" },
  { title: "Holy Cross College Ryde", value: "Holy Cross College Ryde" },
  { title: "Holy Spirit Collage Lakemba", value: "Holy Spirit Collage Lakemba" },
  { title: "Homebush Boys High School", value: "Homebush Boys High School" },
  { title: "Hornsby Girls High School", value: "Hornsby Girls High School" },
  { title: "Hoxton Park High School", value: "Hoxton Park High School" },
  { title: "Hunters Hill High School", value: "Hunters Hill High School" },
  { title: "Hurlstone Agricultural High School", value: "Hurlstone Agricultural High School" },
  { title: "Illawarra Grammar School", value: "Illawarra Grammar School" },
  { title: "Inaburra School", value: "Inaburra School" },
  { title: "Innabura High School", value: "Innabura High School" },
  { title: "International Grammar School", value: "International Grammar School" },
  { title: "James Busby High School", value: "James Busby High School" },
  { title: "James Cook Boys High School", value: "James Cook Boys High School" },
  { title: "James Ruse Agricultural High School", value: "James Ruse Agricultural High School" },
  { title: "Jamison High School", value: "Jamison High School" },
  { title: "John Edmondson High School", value: "John Edmondson High School" },
  { title: "John Therry Catholic High School", value: "John Therry Catholic High School" },
  { title: "Kambala School", value: "Kambala School" },
  { title: "Kellyville High School", value: "Kellyville High School" },
  { title: "Killara High School", value: "Killara High School" },
  { title: "Killarney Heights High School", value: "Killarney Heights High School" },
  { title: "Kincoppal Rose Bay", value: "Kincoppal Rose Bay" },
  { title: "Kingsgrove High School", value: "Kingsgrove High School" },
  { title: "Kingsgrove North High School", value: "Kingsgrove North High School" },
  { title: "Kinross Wolaroi School", value: "Kinross Wolaroi School" },
  { title: "Kirrawee High School", value: "Kirrawee High School" },
  { title: "Knox Grammar School", value: "Knox Grammar School" },
  { title: "Kogarah High School", value: "Kogarah High School" },
  { title: "Ku-ring-gai High School", value: "Ku-ring-gai High School" },
  { title: "Lambton High School", value: "Lambton High School" },
  { title: "La Salle Catholic College", value: "La Salle Catholic College" },
  { title: "Lindfield Public School", value: "Lindfield Public School" },
  { title: "Loreto High School", value: "Loreto High School" },
  { title: "Loreto Kirribilli", value: "Loreto Kirribilli" },
  { title: "Loreto Normanhurst", value: "Loreto Normanhurst" },
  { title: "Macarthur Anglican School", value: "Macarthur Anglican School" },
  { title: "Macarthur Girls High School", value: "Macarthur Girls High School" },
  { title: "Macquarie Fields High School", value: "Macquarie Fields High School" },
  { title: "Macquarie University", value: "Macquarie University" },
  { title: "Magdalene Catholic High School", value: "Magdalene Catholic High School" },
  { title: "Malek Fahd Islamic School", value: "Malek Fahd Islamic School" },
  { title: "Marcellin College", value: "Marcellin College" },
  { title: "Marian Catholic College", value: "Marian Catholic College" },
  { title: "Marist Catholic College Penshurst", value: "Marist Catholic College Penshurst" },
  { title: "Marist College Eastwood", value: "Marist College Eastwood" },
  { title: "Marist College Kogarah", value: "Marist College Kogarah" },
  { title: "Marist College North Shore", value: "Marist College North Shore" },
  { title: "Marist Sisters College Woolwich", value: "Marist Sisters College Woolwich" },
  { title: "Marrickville High School", value: "Marrickville High School" },
  { title: "Marsden High School", value: "Marsden High School" },
  { title: "Mary Mackillop Catholic College Wakeley", value: "Mary Mackillop Catholic College Wakeley" },
  { title: "Masada College", value: "Masada College" },
  { title: "Mater Maria Catholic College Warriewood", value: "Mater Maria Catholic College Warriewood" },
  { title: "McMarthur Girls High School", value: "McMarthur Girls High School" },
  { title: "Menai High School", value: "Menai High School" },
  { title: "Mercy Catholic College", value: "Mercy Catholic College" },
  { title: "Mereweather High school", value: "Mereweather High school" },
  { title: "Meriden School", value: "Meriden School" },
  { title: "Merrylands High School", value: "Merrylands High School" },
  { title: "Mitchell High School", value: "Mitchell High School" },
  { title: "MLC School", value: "MLC School" },
  { title: "Model Farms High School", value: "Model Farms High School" },
  { title: "Monte Sant' Angelo Mercy College", value: "Monte Sant' Angelo Mercy College" },
  { title: "Moorebank High School", value: "Moorebank High School" },
  { title: "Mortlake Public School", value: "Mortlake Public School" },
  { title: "Mosman High School", value: "Mosman High School" },
  { title: "Mount Annan Christian College", value: "Mount Annan Christian College" },
  { title: "Mount St Benedict College", value: "Mount St Benedict College" },
  { title: "Mount St Joseph Milperra", value: "Mount St Joseph Milperra" },
  { title: "Nagle College", value: "Nagle College" },
  { title: "NBSC Cromer Campus", value: "NBSC Cromer Campus" },
  { title: "NBSC Mackellar Girls Campus", value: "NBSC Mackellar Girls Campus" },
  { title: "NBSC Manly Campus", value: "NBSC Manly Campus" },
  { title: "Newcastle Grammar School", value: "Newcastle Grammar School" },
  { title: "Newington College", value: "Newington College" },
  { title: "Newtown High School of the Performing Arts", value: "Newtown High School of the Performing Arts" },
  { title: "Normanhurst Boys High School", value: "Normanhurst Boys High School" },
  { title: "North Sydney Boys High School", value: "North Sydney Boys High School" },
  { title: "North Sydney Girls High School", value: "North Sydney Girls High School" },
  { title: "Northern Beaches Christian School", value: "Northern Beaches Christian School" },
  { title: "Northern Beaches Secondary College", value: "Northern Beaches Secondary College" },
  { title: "Northmead Creative and Performing Arts High School", value: "Northmead Creative and Performing Arts High School" },
  { title: "Northmead High School", value: "Northmead High School" },
  { title: "Norwest Christian College", value: "Norwest Christian College" },
  { title: "Oakhill College", value: "Oakhill College" },
  { title: "Oatley Senior Campus", value: "Oatley Senior Campus" },
  { title: "OTEN", value: "OTEN" },
  { title: "Our Lady of Mercy College Parramatta", value: "Our Lady of Mercy College Parramatta" },
  { title: "Our Lady of Sacred Heart College", value: "Our Lady of Sacred Heart College" },
  { title: "Oxford Falls Grammar School", value: "Oxford Falls Grammar School" },
  { title: "Pacific Hills Christian School", value: "Pacific Hills Christian School" },
  { title: "Parramatta High School", value: "Parramatta High School" },
  { title: "Parramatta Marist High School", value: "Parramatta Marist High School" },
  { title: "Parramatta West Public School", value: "Parramatta West Public School" },
  { title: "Patrician Brothers' College Blacktown", value: "Patrician Brothers' College Blacktown" },
  { title: "Patrician Brothers' College Fairfield", value: "Patrician Brothers' College Fairfield" },
  { title: "Pendle Hill High School", value: "Pendle Hill High School" },
  { title: "Pennant Hills High School", value: "Pennant Hills High School" },
  { title: "Penrith Academic High School", value: "Penrith Academic High School" },
  { title: "Penrith High School", value: "Penrith High School" },
  { title: "Penshurst Girls High School", value: "Penshurst Girls High School" },
  { title: "Picnic Point High School", value: "Picnic Point High School" },
  { title: "Pittwater House", value: "Pittwater House" },
  { title: "PLC Armidale", value: "PLC Armidale" },
  { title: "Plumpton High School", value: "Plumpton High School" },
  { title: "Port Hacking High School", value: "Port Hacking High School" },
  { title: "Prairiewood High School", value: "Prairiewood High School" },
  { title: "Presbyterian Ladies' College Sydney", value: "Presbyterian Ladies' College Sydney" },
  { title: "Pymble Ladies' College", value: "Pymble Ladies' College" },
  { title: "Quakers Hill High School", value: "Quakers Hill High School" },
  { title: "Queenswood School For Girls", value: "Queenswood School For Girls" },
  { title: "Randwick Boys High School", value: "Randwick Boys High School" },
  { title: "Randwick Girls High School", value: "Randwick Girls High School" },
  { title: "Ravenswood School for Girls", value: "Ravenswood School for Girls" },
  { title: "Reddam House", value: "Reddam House" },
  { title: "Redeemer Baptist School", value: "Redeemer Baptist School" },
  { title: "Redfield College", value: "Redfield College" },
  { title: "Redlands", value: "Redlands" },
  { title: "Regents Park Christian School", value: "Regents Park Christian School" },
  { title: "Richard Johnson Anglican School", value: "Richard Johnson Anglican School" },
  { title: "Riverside Girls High School", value: "Riverside Girls High School" },
  { title: "Riverview St Ignatius", value: "Riverview St Ignatius" },
  { title: "Rose Bay Secondary College", value: "Rose Bay Secondary College" },
  { title: "Rosebank College", value: "Rosebank College" },
  { title: "Roseville College", value: "Roseville College" },
  { title: "Rouse Hill Angelican College", value: "Rouse Hill Angelican College" },
  { title: "Rouse Hill High School", value: "Rouse Hill High School" },
  { title: "Ryde Secondary College", value: "Ryde Secondary College" },
  { title: "Saint Ignatius' College Riverview", value: "Saint Ignatius' College Riverview" },
  { title: "Saint Mark's Coptic Orthodox College", value: "Saint Mark's Coptic Orthodox College" },
  { title: "Saint Patrick's Dundas", value: "Saint Patrick's Dundas" },
  { title: "Santa Sabina College", value: "Santa Sabina College" },
  { title: "Sarah Redfern High School", value: "Sarah Redfern High School" },
  { title: "SCECGS Redlands", value: "SCECGS Redlands" },
  { title: "SCEGGS Darlinghurst", value: "SCEGGS Darlinghurst" },
  { title: "SCEGGS Darlinghurst", value: "SCEGGS Darlinghurst" },
  { title: "Scots College", value: "Scots College" },
  { title: "Sefton High School", value: "Sefton High School" },
  { title: "Sir Joseph Banks High School", value: "Sir Joseph Banks High School" },
  { title: "Smith's Hill High School", value: "Smith's Hill High School" },
  { title: "St Aloysius' College", value: "St Aloysius' College" },
  { title: "St Andrew's Cathedral Sydney", value: "St Andrew's Cathedral Sydney" },
  { title: "St Augustine's College", value: "St Augustine's College" },
  { title: "St Benedicts Catholic College", value: "St Benedicts Catholic College" },
  { title: "St Catherine's School", value: "St Catherine's School" },
  { title: "St Clare's College Waverley", value: "St Clare's College Waverley" },
  { title: "St Columba's Catholic College", value: "St Columba's Catholic College" },
  { title: "St Euphemia College", value: "St Euphemia College" },
  { title: "St George Christian School", value: "St George Christian School" },
  { title: "St George Girls High School", value: "St George Girls High School" },
  { title: "St Ignatius College Riverview", value: "St Ignatius College Riverview" },
  { title: "St Ives High School", value: "St Ives High School" },
  { title: "St John Paul II", value: "St John Paul II" },
  { title: "St Johns College Dubbo", value: "St Johns College Dubbo" },
  { title: "St Johns Park High School", value: "St Johns Park High School" },
  { title: "St Joseph's College", value: "St Joseph's College" },
  { title: "St Leo's Catholic College", value: "St Leo's Catholic College" },
  { title: "St Lukes Grammar School", value: "St Lukes Grammar School" },
  { title: "St Mark's Catholic College", value: "St Mark's Catholic College" },
  { title: "St Maroun's College", value: "St Maroun's College" },
  { title: "St Mary & St Mina's Coptic Orthodox College", value: "St Mary & St Mina's Coptic Orthodox College" },
  { title: "St Mary Star of the Sea College Wollongong", value: "St Mary Star of the Sea College Wollongong" },
  { title: "St Mary's Cathedral College Sydney", value: "St Mary's Cathedral College Sydney" },
  { title: "St Mary's Senior High School", value: "St Mary's Senior High School" },
  { title: "St Michael's Belfield", value: "St Michael's Belfield" },
  { title: "St Patrick's College Campbelltown", value: "St Patrick's College Campbelltown" },
  { title: "St Patrick's College Strathfield", value: "St Patrick's College Strathfield" },
  { title: "St Patrick's College Sutherland", value: "St Patrick's College Sutherland" },
  { title: "St Patrick's Marist College", value: "St Patrick's Marist College" },
  { title: "St Pauls Catholic College", value: "St Pauls Catholic College" },
  { title: "St Paul's Gramma School", value: "St Paul's Gramma School" },
  { title: "St Phillip's Christian College", value: "St Phillip's Christian College" },
  { title: "St Pius X College", value: "St Pius X College" },
  { title: "St Scholastica's College", value: "St Scholastica's College" },
  { title: "St Ursula's College Kingsgrove", value: "St Ursula's College Kingsgrove" },
  { title: "St Vincent's College", value: "St Vincent's College" },
  { title: "St Vincent's College", value: "St Vincent's College" },
  { title: "Stella Maris College", value: "Stella Maris College" },
  { title: "Strathfield Girls High School", value: "Strathfield Girls High School" },
  { title: "Strathfield South High School", value: "Strathfield South High School" },
  { title: "Sydney Boys High School", value: "Sydney Boys High School" },
  { title: "Sydney Church of England Grammar School", value: "Sydney Church of England Grammar School" },
  { title: "Sydney Girls High School", value: "Sydney Girls High School" },
  { title: "Sydney Grammar School", value: "Sydney Grammar School" },
  { title: "Sydney Secondary College Balmain Campus", value: "Sydney Secondary College Balmain Campus" },
  { title: "Sydney Secondary College Blackwattle Bay Campus", value: "Sydney Secondary College Blackwattle Bay Campus" },
  { title: "Sydney Secondary College Leichhardt Campus", value: "Sydney Secondary College Leichhardt Campus" },
  { title: "Sydney Technical High School", value: "Sydney Technical High School" },
  { title: "Tanagra School for Girls", value: "Tanagra School for Girls" },
  { title: "Tara Anglican School for Girls", value: "Tara Anglican School for Girls" },
  { title: "Taylors College", value: "Taylors College" },
  { title: "Tempe High School", value: "Tempe High School" },
  { title: "Terra Sancta College", value: "Terra Sancta College" },
  { title: "The Conservatorium High School", value: "The Conservatorium High School" },
  { title: "The Forest High School", value: "The Forest High School" },
  { title: "The Hills Grammar School", value: "The Hills Grammar School" },
  { title: "The Illawarra Grammar School", value: "The Illawarra Grammar School" },
  { title: "The King's School", value: "The King's School" },
  { title: "The McDonald College", value: "The McDonald College" },
  { title: "The Ponds High School", value: "The Ponds High School" },
  { title: "The Scots College", value: "The Scots College" },
  { title: "Thomas Hassall Anglican College", value: "Thomas Hassall Anglican College" },
  { title: "Toongabbie Christian School", value: "Toongabbie Christian School" },
  { title: "Trinity Anglican College - Albury", value: "Trinity Anglican College - Albury" },
  { title: "Trinity Catholic College", value: "Trinity Catholic College" },
  { title: "Trinity Grammar School", value: "Trinity Grammar School" },
  { title: "Turramurra High School", value: "Turramurra High School" },
  { title: "Tyndale Christian High School", value: "Tyndale Christian High School" },
  { title: "Unity Grammar College", value: "Unity Grammar College" },
  { title: "University of Newcastle", value: "University of Newcastle" },
  { title: "University of Sydney", value: "University of Sydney" },
  { title: "University of Western Sydney", value: "University of Western Sydney" },
  { title: "UNSW", value: "UNSW" },
  { title: "UTS Insearch", value: "UTS Insearch" },
  { title: "Waverley College", value: "Waverley College" },
  { title: "Wenona School", value: "Wenona School" },
  { title: "West Ryde Public School", value: "West Ryde Public School" },
  { title: "Westfields Sports High School", value: "Westfields Sports High School" },
  { title: "Wiley Park Public School", value: "Wiley Park Public School" },
  { title: "William Carey Christian School", value: "William Carey Christian School" },
  { title: "William Clarke College", value: "William Clarke College" },
  { title: "Willoughby Girls High School", value: "Willoughby Girls High School" },
  { title: "Wollemi College", value: "Wollemi College" },
  { title: "Wollongong High School of the Performing Arts", value: "Wollongong High School of the Performing Arts" },
  { title: "Wyndham College", value: "Wyndham College" },
  { title: "Xavier College", value: "Xavier College" },
  { title: "Xavier Catholic College Ballina", value: "Xavier Catholic College Ballina" },
  { title: "Unknown", value: "Unknown" },
]



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/schools.ts